module.exports = __webpack_public_path__ + "static/media/barra_do_pirai.7bc6b73a.png";